// extracted by mini-css-extract-plugin
export var banner = "_3d-0";
export var icon = "_3d-1";
export var message = "_3d-2";